import { createSelector } from 'react-sweet-state';

import type { FormRendererState } from '../../types';

export const lifecycleHandlersSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	import('../../../..').LifecycleHandlers
> = createSelector(
	(state: FormRendererState) => state.lifecycleHandlers,
	(lifecycleHandlers) => lifecycleHandlers,
);
